module.exports = __webpack_public_path__ + "img/135671bebdfa6ccd186174b231402488.png";